// Shared constants for notes module

export const DEFAULT_TYPE = 'DEFAULT';
export const PUBLIC_NOTE_MAPPER =
    'Platform360\\Service\\NoteBook\\Domain\\TypeNote\\ClassMapperData\\PublicNote\\PublicNoteClassMapperData';
export const GLOBAL_NOTE_MAPPER = 'Platform360\\Service\\NoteBook\\Domain\\GlobalNote\\GlobalNote';

export const MC_NOTE_HISTORY = 'MCNoteHistory';
export const LINKED_NOTE_TITLE = '__LINKED_NOTE__';
